module.exports = __webpack_public_path__ + "img/bannerServicoRenegociacaoDivida.4e146ecd.jpg";